'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  title: string;
  center?: boolean;
  uppercase?: boolean;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  color?: 'white' | 'black';
  subtitle?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  /** Override document semantics while retaining the existing tag's visual class. */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
}

export function Heading({
  title,
  className,
  tag = 'h2',
  as,
  center = false,
  color = 'black',
  uppercase = false,
  subtitle,
}: HeadingProps) {
  const Tag = as ?? tag;

  return (
    <div
      className={cn(
        'ea-heading__container',
        'flex flex-col items-start justify-start',
        className?.container,
        center && 'items-center justify-center text-center',
        subtitle && 'gap-4 sm:gap-5 lg:gap-6',
      )}
    >
      {!!subtitle && (
        <h3
          className={cn(
            'flex h-[25px] items-center justify-center bg-[#EFF4FF] px-2 text-xs font-bold uppercase text-black sm:h-[28px] sm:text-sm',
            'ea-heading__subtitle',
            'font-heading',
            className?.subtitle,
          )}
        >
          {subtitle}
        </h3>
      )}
      <HtmlRendererRaw
        as={Tag}
        data-ea-visual-tag={as ? tag : undefined}
        className={cn(
          'relative z-[5] text-left font-bold tracking-tighter text-black',
          color === 'white' && 'text-white',
          center && 'text-center',
          uppercase && 'uppercase',
          tag,
          className?.title,
          'ea-heading__title',
        )}
        html={title}
      />
    </div>
  );
}
